"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DataSource {
    constructor(_dataSourceImpl) {
        this._dataSourceImpl = _dataSourceImpl;
    }
    get name() {
        return this._dataSourceImpl.name;
    }
    get id() {
        return this._dataSourceImpl.id;
    }
    get fields() {
        return this._dataSourceImpl.fields;
    }
    get extractUpdateTime() {
        return this._dataSourceImpl.extractUpdateTime;
    }
    get isExtract() {
        return this._dataSourceImpl.isExtract;
    }
    get isPublished() {
        return this._dataSourceImpl.isPublished;
    }
    publishedUrl() {
        return this._dataSourceImpl.publishedUrl();
    }
    refreshAsync() {
        return this._dataSourceImpl.refreshAsync();
    }
    getActiveTablesAsync() {
        console.warn('DataSource.getActiveTablesAsync is deprecated. Please use DataSource.getLogicalTablesAsync.');
        return this._dataSourceImpl.getActiveTablesAsync();
    }
    getConnectionSummariesAsync() {
        return this._dataSourceImpl.getConnectionSummariesAsync();
    }
    getUnderlyingDataAsync(options) {
        console.warn('DataSource.getUnderlyingDataAsync is deprecated. Please use ' +
            'DataSource.getLogicalTablesAsync and DataSource.getLogicalTableDataAsync.');
        return this._dataSourceImpl.getUnderlyingDataAsync(options);
    }
    getLogicalTablesAsync() {
        return this._dataSourceImpl.getLogicalTablesAsync();
    }
    getLogicalTableDataAsync(logicalTableId, options) {
        return this._dataSourceImpl.getLogicalTableDataAsync(logicalTableId, options);
    }
    getLogicalTableDataReaderAsync(logicalTableId, pageRowCount, options) {
        return this._dataSourceImpl.getLogicalTableDataReaderAsync(logicalTableId, pageRowCount, options);
    }
}
exports.DataSource = DataSource;
//# sourceMappingURL=DataSource.js.map